import { Injectable } from '@angular/core';
import { StaffTask } from '@models/staff-task/staff-task';
import { HttpService } from '@services/http.service';

import { BehaviorSubject, Observable } from 'rxjs';


@Injectable({
    providedIn: 'root'
})
export class StaffTasksService extends HttpService {
    private staffTasksSubject = new BehaviorSubject<StaffTask[]>([]);
    private isLoadingDataSubject = new BehaviorSubject<boolean>(true);
    private dataStore: { staffTasks: StaffTask[] } = { staffTasks: [] };

    get staffTasks(): Observable<StaffTask[]> {
        return this.staffTasksSubject.asObservable();
    }

    get loadingData(): Observable<boolean> {
        return this.isLoadingDataSubject.asObservable();
    }

    list(idRole: string): void {
        this.loading(true);
        this.listServices(idRole).subscribe(
            () => {
                this.next([ ...this.dataStore.staffTasks ]);
                this.loading(false);
            }
        );
    }

    search(idTask: string): void {
        this.get(`customer/services/${idTask}`, { app: 'member', version: 3 }).subscribe(
            data => {
                const index: number = this.dataStore.staffTasks.findIndex(c => c.id === idTask);
                if (index > -1) {
                    this.dataStore.staffTasks[index] = new StaffTask().build(data);
                } else {
                    this.dataStore.staffTasks.push(new StaffTask().build(data));
                }

                this.next([ ...this.dataStore.staffTasks ]);
            }
        );
    }

    private listServices(idRole: string): Observable<boolean> {
        return new Observable<boolean>(
            observable => {
                this.get(`customer/services?idCategory=${idRole}`, { app: 'member', version: 3 }).subscribe(
                    data => {
                        this.dataStore.staffTasks = [];
                        data.forEach((payment: any) => {
                            this.dataStore.staffTasks.push(new StaffTask().build(payment));
                        });

                        observable.next(true);
                    }, () => observable.next(false)
                );
            }
        );
    }

    private next(data: StaffTask[]): void {
        this.staffTasksSubject.next(data);
    }

    private loading(value: boolean): void {
        this.isLoadingDataSubject.next(value);
    }
}
